<nb-layout>
  <nb-layout-column>
    <div id="login-container" class="center vertical">
    <nb-card>
      <nb-card-header>
        <img alt="My image name" src="./assets/images/logosmartruralheader.png" class="logo-login">
      </nb-card-header>
      <nb-card-body>
        <nb-auth-block>
          <router-outlet></router-outlet>
        </nb-auth-block>
      </nb-card-body>
    </nb-card>
  </div>
  </nb-layout-column>
</nb-layout>
